import React from 'react';
import PropTypes from 'prop-types';
import { getCurrencyParts, getAmountPlaceHolder } from '../../utility/formator';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import colors from '../../styles/colors';
import * as amountUtils from './amountUtils';
import { localsMessages } from '../../utility/getTemplateData';
import { TextInput } from '@paypalcorp/pp-react-text-input';
import classNames from 'classnames';

let messages = localsMessages('common/amount');

const STYLES = StyleSheet.create({
	currencyString: {
		position: 'absolute',
		'font-size': '16px',
		'line-height': '1',
		color: colors.black,
		zIndex: 1,
		top: '14px',
		left: '8px'
	},
	amountCondensed: {
		display: 'inline-block',
		margin: '0 auto',
		width: '100%'
	},
	moneyInput: {
		width: '142px',
		maxWidth: '282px',
		position: 'relative',
		marginLeft: '10px',
		
		'@media (max-width: 736px)': {
			width: '100%',
			margin: '0 auto'
		}
	},
	inputField: {
		fontSize: '13px',
		height: '3.1rem',
		width: '140px'
	},
	error: {
		color: '#d20000'
	}
});

class AmountCondensed extends React.Component {
	constructor(props) {
		super(props);
		const [firstParts = {}] = getCurrencyParts();
		const displayValue = this.getDisplayValue(this.props.amount);
		this.state = {
			displayValue,
			amount: this.props.amount || '',
			symbol: this.props.symbol || '',
			code: this.props.code || '',
			rightSymbol: firstParts.$ !== 'symbol',
			placeholder: getAmountPlaceHolder()
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.state.amount !== nextProps.amount) {
			this.setState({
				amount: nextProps.amount
			});

			if (!nextProps.amount) {
				this.setState({
					displayValue: ''
				})
			}
		}
	}

	/**
	 * Returns amount converted to readable format
	 * Converts "1.00"
	 * @return {[type]} [description]
	 */
	getDisplayValue(amount) {
		// let amount = inputAmount || this.state.amount;
		if (!amount) {
			return '';
		}
		let displayValue;
		if (this.props.symbol) {
			displayValue = `${this.props.symbol}${amount} ${this.props.code}`;
		} else {
			displayValue = `${amount} ${this.props.code}`;
		}
		return displayValue;
	}

	moveCursorToTheEnd(node) {
		if (node) {
			setTimeout(() => {
				const { length } = node.value
				node.setSelectionRange(length, length);
			});
		}
	}

	handleFocus = (event) => {
		if (!this.state.amount) {
			this.props.handleAmount(amountUtils.formatAmount('', this.props.code));
		}
		this.setState({
			displayValue: ''
		});
		this.moveCursorToTheEnd(event.target);
	}

	handleKeyPress = (event) => {
		if (!amountUtils.isKeyAllowed(event.charCode)) {
			return;
		}
	}

	handleChange = (event) => {
		const { value } = event.target;
		if (!amountUtils.amountLengthValid(value)) {
			return;
		}
		const stringValue = amountUtils.formatAmount(value, this.props.code);
		this.props.handleAmountFocus();
		this.setState({ amount: stringValue });
		this.props.handleAmount(stringValue);
	}

	handleBlur = (event) => {
		const amount = this.state.amount;
		this.setState({
			displayValue: this.getDisplayValue(amount)
		});
	}

	handleClick = ({ target }) => this.moveCursorToTheEnd(target)

	render() {
		const placeholder = messages.amount.placeholderOtherAmount;
		const amount = `${this.state.amount}`;
		const hasError = !!this.props.showValidationError;
		const displayedAmount = this.state.displayValue ? this.state.displayValue : amount;

		const inputStyles = classNames('money_input', css(STYLES.inputField), css(STYLES.moneyInput));

		return (
			<TextInput
				className={`${inputStyles} ${hasError ? 'ppvx_field--error' : ''}`}
				name="donationAmount"
				id="currencyAmount"
				data-testid="currencyAmount"
				autoComplete="off"
				label={placeholder}
				value={displayedAmount}
				onKeyPress={this.handleKeyPress}
				onClick={this.handleClick}
				onChange={this.handleChange.bind(this)}
				onFocus={this.handleFocus}
				onBlur={this.handleBlur}
			/>
		);
	}
}

AmountCondensed.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string,
	amount: PropTypes.string,
	symbol: PropTypes.string,
	code: PropTypes.string,
	decimalPoint: PropTypes.string,
	isEditable: PropTypes.bool,
	handleAmount: PropTypes.func,
	showValidationError: PropTypes.bool,
	validateDonationAmount: PropTypes.func,
	validationErrorMessage: PropTypes.string,
	handleAmountFocus: PropTypes.func
};

export default AmountCondensed
